<template>
  <div :class= "['file-table-item-wrapper', { selected: props.isSelected }]">
    <div class="file-table-item-icon">
      <div :class="fileIcon" />
    </div>
    <div :class="['file-table-item', { selected: isSelected }]" @click="selectItem" @blur="unfocusItem">
      <div class="file-table-item-name">{{ props.fileInfo.name }}</div>
      <div class="file-table-item-size">{{ formatBytes(props.fileInfo.size) }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatBytes } from '@/utils/format-bytes'
import { extension, getIconClass } from '@/utils/get-icon'

const props = defineProps({
  fileInfo: Object,
  isSelected: Boolean,
})

const fileIcon = computed(() => {
  const cls = 'file-table-item-icon'
  if (props.fileInfo.type === 'folder') {
    return cls + ' folder'
  }
  return cls + ' ' + getIconClass(extension(props.fileInfo.name))
})

</script>

<style lang="scss" scoped>
@import '@/mixins/style.scss';

.folder {
  background-image: url('@/assets/filetype/folder.png');
  background-size: 100%;
}
.file-table-item-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 420px;
  height: 48px;
  padding: 8px 12px;
  box-sizing: border-box;
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.15) inset;
  cursor: pointer;
  .file-table-item-icon {
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
  }
  .file-table-item {
    margin-left: 8px;
    display: flex;
    flex: 1;
    color: rgba(255, 255, 255, 0.70);
    align-items: flex-start;
    justify-content: space-between;
    gap: 40px;
    .file-table-item-name {
      width: 224px;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .file-table-item-size {
      width: 100px;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
      text-align: right;
    }
  }
  &.selected {
    background: rgba(255, 255, 255, 0.10);
    cursor: default;
  }
}

</style>

